<div align="right;"><button mat-stroked-button color="" [mat-dialog-close]="true" class="button-close">X</button></div>
<br/><br/><br/>
<div fxLayout="row" fxLayoutAlign="center center" align="center">
    <mat-card >
        <h4>{{msg}}.</h4>
        <button mat-stroked-button color="" [mat-dialog-close]="true" class="button-ok" cdkFocusInitial >OK</button>
    </mat-card>
</div>